function TextWrap(text, maxLength) {
  if (text?.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + "...";
}

export default TextWrap;
